<template>
  <div class="page-block">
    <header-bar v-if="isLoggedIn">ヘルプ</header-bar>
    <div class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">よくある質問</h3>
    </div>
    <div class="page-block__inner">
      <div class="faq-search-wrap">
        <div class="faq-search-text">検索</div>
        <input
          v-model="keyword"
          class="faq-search"
          type="search"
          @keydown.prevent.enter="onClickedSearch('enter',$event)">
        <a
          class="c-btn c-btn--search"
          @click.prevent="onClickedSearch('',$event)">
          <img
            src="/img/common/icon-search.png">検索
        </a>
      </div>
      <div
        class="faq-area">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="faq-area-content">
          <h3 class="faq-area-title">{{ item.title }}</h3>
          <p
            v-for="child in item.faqs"
            :key="child.id"
            class="faq-area-link">
            <router-link
              :to="{ name: 'faq-detail', params: { id: child.id } }"
              class="c-text-link">
              {{ child.title }}
            </router-link>
          </p>
        </div>
      </div>
    </div>
    <div class="c-btn-wrap c-btn-wrap-faq">
      <router-link
        :to="{ name: 'index' }"
        class="c-btn c-btn--back">
        トップへ戻る
        <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderBar from '../HeaderBar'

export default {
  components: { HeaderBar },
  data() {
    return {
      items: [],
      keyword: '',
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
  mounted() {
    this.fetchItems()
  },
  methods: {
    async fetchItems() {
      const publishType = this.isBtoB ? 2 : 1
      const { data } = await window.axios.get(`/api/client/faqs?publish_type=${publishType}`)
      this.items = data.data
    },
    async onClickedSearch(type, event) {
      if (type === 'enter' && event.keyCode !== 13) return
      if (this.keyword) {
        this.$router.push({
          name: 'faq-search',
          query: {
            page: 1,
            keyword: this.keyword,
          },
        })
      }
    },
  },
}

</script>

<style scoped>
.faq-area-link {
  display: block;
}
</style>
